const Explore = () => {
  return (
    <div>
      <h1>Explore Page</h1>
    </div>
  );
};

export default Explore;
